export default __webpack_public_path__ + "static/alloy-embedded-a262318f9156101bd71ee850cb891035.svg";